import { useAuth } from '../../auth/auth-context';

/**
 * The dev-only user switcher. The seeded identities are named in
 * `auth/dev-users.ts`: Lew is the club office, Dana the business one, and
 * Soroush the operator account with no membership row — so switching between
 * them reaches both verticals' vocabularies and the org-less empty state without
 * a second browser.
 *
 * One component, two homes: the nav foot, and the bare page-states, which
 * render without the shell and are exactly where the operator identity strands
 * you. It renders nothing outside dev mode, nor in a sales film build
 * (`VITE_DEV_SWITCH=off`, docs/sales/film.md), which signs in as one person.
 */
export function DevSwitch() {
  const { mode, devUser, devUsers, switchDevUser } = useAuth();
  if (mode !== 'dev' || import.meta.env.VITE_DEV_SWITCH === 'off') return null;

  return (
    <div className="dev-switch">
      <div className="label">Signed in as</div>
      {devUsers.map((user) => (
        <button
          key={user.email}
          type="button"
          className={user.email === devUser?.email ? 'quiet-action current' : 'quiet-action'}
          disabled={user.email === devUser?.email}
          onClick={() => switchDevUser(user.email)}
        >
          {user.name}
        </button>
      ))}
    </div>
  );
}
